const PRESETS = [
  { label: "Flat", x: 0, y: 0 },
  { label: "Lean Right", x: 20, y: 0 },
  { label: "Lean Left", x: -20, y: 0 },
  { label: "Tilt Down", x: 0, y: 15 },
  { label: "Diamond", x: 20, y: 20 },
  { label: "Italic", x: -15, y: 0 },
];

export default PRESETS;
